import entries from 'lodash/fp/entries';
import flow from 'lodash/fp/flow';
import reduce from 'lodash/fp/reduce';

const dayPickerDefaultClasses = {
  container: 'DayPicker',
  wrapper: 'DayPicker-wrapper',
  interactionDisabled: 'DayPicker--interactionDisabled',
  months: 'DayPicker-Months',
  month: 'DayPicker-Month',

  navBar: 'DayPicker-NavBar',
  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',

  caption: 'DayPicker-Caption',
  weekdays: 'DayPicker-Weekdays',
  weekdaysRow: 'DayPicker-WeekdaysRow',
  weekday: 'DayPicker-Weekday',
  body: 'DayPicker-Body',
  week: 'DayPicker-Week',
  weekNumber: 'DayPicker-WeekNumber',
  day: 'DayPicker-Day',
  footer: 'DayPicker-Footer',
  todayButton: 'DayPicker-TodayButton',

  // default modifiers
  today: 'DayPicker-Day--today',
  selected: 'DayPicker-Day--selected',
  disabled: 'DayPicker-Day--disabled',
  outside: 'DayPicker-Day--outside',
  disabledSelected: 'DayPicker-Day--selected DayPicker-Day--disabled',
};

const dayPickerInputDefaultClasses = {
  container: 'DayPickerInput',
  overlayWrapper: 'DayPickerInput-OverlayWrapper',
  overlay: 'DayPickerInput-Overlay',
};

const extendClassName = (initial, [key, value]) => ({
  ...initial,
  [key]: `${initial[key]} ${value}`,
});

const extendClassNames = (base, classes) =>
  flow(entries, reduce(extendClassName, base))(classes);

export {
  dayPickerDefaultClasses,
  dayPickerInputDefaultClasses,
  extendClassNames,
};
